import script from "./LegalList.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalList.vue?vue&type=script&setup=true&lang=js"

import "./LegalList.vue?vue&type=style&index=0&id=235e1f58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-235e1f58"]])

export default __exports__